export enum OrderUpdateMethod {
  continue = 'continue',
  update = 'update',
}
